"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Module = exports.RunMode = void 0;
const Card_1 = require("./Card");
const LegacyDataProvider_1 = require("./DataProviders/LegacyDataProvider");
const FeatureFactory_1 = require("./FeatureFactory");
const debugMode = __importStar(require("./utils/debugMode"));
const SummaryReport_1 = require("./SummaryReport");
const VisibilityObserver_1 = require("./utils/VisibilityObserver");
const ModuleExecutionContext_1 = require("./ModuleExecutionContext");
const DOMEventSender_1 = require("./utils/EventSender/DOMEventSender");
const SummaryRequestSender_1 = require("./utils/EventSender/SummaryRequestSender");
const CardGrouppingDataProvider_1 = require("./DataProviders/CardGrouppingDataProvider");
const PriceFormatter_1 = require("./PriceFormatter");
const SummaryCounter_1 = require("./SummaryCounter");
const InMemoryHtmlElementAttributeHandler_1 = require("./HtmlElementAttributeHandler/InMemoryHtmlElementAttributeHandler");
const HtmlElementAttributeHandler_1 = require("./HtmlElementAttributeHandler/HtmlElementAttributeHandler");
const ModuleScopedServices_1 = require("./utils/ModuleScopedServices");
const urlHelper_1 = require("./utils/urlHelper");
const DynamicButtonsFeature_1 = require("./Features/DynamicButtonsFeature");
const XcreoHandler_1 = require("./utils/XcreoHandler");
const evaluate_1 = require("./utils/Conditions/evaluate");
const StyleInjectionFeature_1 = require("./Features/StyleInjectionFeature");
var RunMode;
(function (RunMode) {
    RunMode[RunMode["NoRun"] = 0] = "NoRun";
    RunMode[RunMode["Production"] = 1] = "Production";
    RunMode[RunMode["Silent"] = 2] = "Silent";
})(RunMode || (exports.RunMode = RunMode = {}));
class Module {
    #config;
    #context = null;
    #moduleScopedServices;
    constructor(config) {
        if (!config)
            throw new Error("config is required");
        this.#config = config;
        this.debugMode = debugMode.isDebugModeSignaled();
        const featureFactory = new FeatureFactory_1.FeatureFactory();
        this.#registerFeatures(featureFactory);
        this.#moduleScopedServices = new ModuleScopedServices_1.ModuleScopedServices(featureFactory);
    }
    get debugMode() {
        return debugMode.isDebugModeEnabled();
    }
    set debugMode(value) {
        if (!value && debugMode.isDebugModeEnabled()) {
            debugMode.disableDebugMode();
        }
        else if (value && !debugMode.isDebugModeEnabled()) {
            debugMode.enableDebugMode();
        }
    }
    get buildNo() {
        return __GIT_HEX_SHA;
    }
    get config() {
        return this.#config;
    }
    get services() {
        return this.#moduleScopedServices;
    }
    get executionCtx() {
        return this.#context;
    }
    #getRunMode() {
        if (!this.#config.runModeConditions) {
            return RunMode.NoRun;
        }
        if ((0, evaluate_1.evaluate)(this.#config.runModeConditions.preconditions)) {
            if ((0, evaluate_1.evaluate)(this.#config.runModeConditions.isProduction)) {
                return RunMode.Production;
            }
            else if ((0, evaluate_1.evaluate)(this.#config.runModeConditions.isSilent)) {
                return RunMode.Silent;
            }
        }
        return RunMode.NoRun;
    }
    /**
     * @param reason Is a string that describes the reason for the execution of the module.
     * @returns Promise<void>
     */
    async execute(impressionId, reason = "page-load") {
        if (this.#context?.isExecuting) {
            return;
        }
        const runMode = this.#getRunMode();
        if (runMode === RunMode.NoRun) {
            return;
        }
        impressionId = impressionId ?? this.#calculateImpressionId();
        const isRecommendationEnabled = this.#config.isRecommendationEnabledFunc ??
            ((runMode, impressionId) => this.#isRecommendationEnabled(runMode, impressionId));
        if (!isRecommendationEnabled(runMode, impressionId)) {
            return;
        }
        this.#setupExecutionContext(impressionId, runMode);
        try {
            this.#initFeatures();
            this.#setBasicSummaryEventValues(reason);
            this.#collectFeatureData();
            await this.#getData();
            this.#executeFeatures();
            this.#onAfterFeaturesExecuted();
            this.#context?.summaryBuilder.setCounts(this.#context?.summaryCounters);
            await this.#reportSummary();
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.#finishExecution();
        }
    }
    #onAfterFeaturesExecuted() {
        if (typeof this.#config.onAfterCardsExecuted === "function") {
            this.#config.onAfterCardsExecuted(this);
        }
    }
    #finishExecution() {
        this.#context?.finishExecution();
    }
    async #reportSummary() {
        return new Promise((resolve) => {
            const summaryData = this.#context?.summaryBuilder.build();
            if (summaryData) {
                const summaryRequestSender = new SummaryRequestSender_1.SummaryRequestSender();
                summaryRequestSender.sendEvent(summaryData);
            }
            else {
                console.error("Links and Buttons - Summary data is not available");
            }
            resolve();
        });
    }
    async #getData() {
        await this.#context?.dataProvider.execute(this.#context?.impressionId);
    }
    #setupExecutionContext(impressionId, runMode) {
        const summaryBuilder = new SummaryReport_1.SummaryReportBuilder(this.buildNo, this.#config.skimlinksPublisherId, this.#config.skimlinksPublisherDomainId);
        const domEventSender = new DOMEventSender_1.DOMEventSender();
        const visibilityObserver = new VisibilityObserver_1.VisibilityObserver(summaryBuilder, domEventSender);
        const priceFormatter = new PriceFormatter_1.PriceFormatter(this.#config.priceFormat);
        const summaryCounter = new SummaryCounter_1.SummaryCounter();
        let dataProvider;
        if (this.config.useNewProductApi) {
            const requestUrl = (0, urlHelper_1.addQueryParamsToUrl)(this.config.skimlinksRequestUrl, this.config.skimlinksRequestUrlParams);
            dataProvider = new CardGrouppingDataProvider_1.CardGrouppingDataProvider(requestUrl, 100, summaryBuilder);
        }
        else {
            const oldRequestUrl = (0, urlHelper_1.addQueryParamsToUrl)(this.config.oldSkimlinksRequestUrl, this.config.oldSkimlinksRequestUrlParams);
            dataProvider = new LegacyDataProvider_1.LegacyDataProvider(oldRequestUrl, 100, summaryBuilder);
        }
        const htmlElementAttributeHandler = runMode === RunMode.Silent ? new InMemoryHtmlElementAttributeHandler_1.InMemoryHtmlElementAttributeHandler() : new HtmlElementAttributeHandler_1.HtmlElementAttributeHandler();
        this.#context = new ModuleExecutionContext_1.ModuleExecutionContext(this, summaryBuilder, visibilityObserver, dataProvider, domEventSender, priceFormatter, impressionId, summaryCounter, htmlElementAttributeHandler, runMode);
    }
    #registerFeatures(featureFactory) {
        featureFactory.register("DynamicButtonsFeature", (featureConfig, card, context) => {
            const xcreoHandler = new XcreoHandler_1.XcreoHandler(context.htmlElementAttributeHandler);
            return new DynamicButtonsFeature_1.DynamicButtonsFeature(featureConfig, card, context, xcreoHandler);
        });
        featureFactory.register("StyleInjectionFeature", (featureConfig, card, {}) => new StyleInjectionFeature_1.StyleInjectionFeature(featureConfig, card));
        for (const [featureKind, factoryFn] of Object.entries(this.#config.addonFeatureRegistry ?? {})) {
            featureFactory.register(featureKind, factoryFn);
        }
    }
    #initFeatures() {
        if (this.#context === null) {
            throw new Error("Context is not initialized");
        }
        let cardIndex = 0;
        for (const sectionConfig of this.#config.sections) {
            const uiElements = Array.from(document.querySelectorAll(sectionConfig.cardSelector));
            if (uiElements.length === 0) {
                continue;
            }
            for (const uiElement of uiElements) {
                const skipCardSelector = this.#config.skipCardSelector;
                if (skipCardSelector && (uiElement.querySelector(skipCardSelector) || uiElement.closest(skipCardSelector)))
                    continue;
                let card = new Card_1.Card(uiElement, this, sectionConfig, cardIndex++);
                this.#context.cards.push(card);
                for (let featureConfiguration of sectionConfig.featureConfigs) {
                    const feature = this.#moduleScopedServices.featureFactory.createFeature(featureConfiguration, card, this.#context);
                    card.features.push(feature);
                }
            }
        }
    }
    /**
     * Execute all features
     */
    #executeFeatures() {
        for (const card of this.#context.cards) {
            const featureExecutionResults = [];
            for (const feature of card.features) {
                const success = feature.apply(this.#context.dataProvider, featureExecutionResults);
                featureExecutionResults.push({ feature, success });
            }
            if (typeof this.#config.onAfterCardExecuted === "function") {
                this.#config.onAfterCardExecuted(card);
            }
        }
    }
    /**
     * Provide input context from all features
     */
    #collectFeatureData() {
        for (const card of this.#context.cards) {
            for (const feature of card.features) {
                feature.populateInputData(this.#context.dataProvider);
            }
        }
    }
    #setBasicSummaryEventValues(reason) {
        this.#context?.summaryBuilder.setPageUrl(window.location.href);
        this.#context?.summaryBuilder.setImpressionId(this.#context?.impressionId);
        this.#context?.summaryBuilder.setSilentMode(this.#context?.isSilentMode);
        this.#context?.summaryBuilder.setExecutionReason(reason);
        this.#context?.summaryBuilder.setExecutionId(this.#context.executionId);
        this.#context?.summaryBuilder.setBrowserAgent(navigator.userAgent);
        this.#context?.summaryBuilder.setConfigVariantId(this.#config.configVariantId);
        this.#context?.summaryBuilder.setBrowserTime(new Date().toString());
        this.#context?.summaryBuilder.setCardCount(this.#context.cards.length);
    }
    #calculateImpressionId() {
        return window.__SKIM_JS_BTN_WIDGET__?.impression_id ?? undefined;
    }
    #publisherSpecificRecommendationEnabled = () => {
        return this.#config.publisherSpecificRecommendationEnabled === undefined ? true : this.#config.publisherSpecificRecommendationEnabled();
    };
    #isRecommendationEnabled = (runMode, impressionId) => this.#publisherSpecificRecommendationEnabled() &&
        this.#config.hasOwnProperty("sections") &&
        this.#config.sections.length > 0 &&
        (runMode !== RunMode.Production || impressionId != undefined);
}
exports.Module = Module;
